import React from 'react';
import { Copyright } from '../../copyright';
import FooterItem from './footer-item';
import { FooterRow, FooterWrapper } from '../styles/footer.style';
/* eslint-disable */
/**
 * Footer Component
 * @returns {XML} A rendered Footer
 */
const Footer = ({ showModal, teams, modals }) => {
  let teamsLink = '';
  if (teams && teams.edges && teams.edges.length > 0) {
    teamsLink = `/teams/${teams.edges[0].node.urlSlug}`;
  }
  return (
    <FooterWrapper>
      <FooterRow>
        <FooterItem target={teamsLink} text="Teams" primary />
        <FooterItem target="/football" text="Football" primary />
        <FooterItem target="/tickets" text="Tickets" primary />
        <FooterItem target="https://www.teamworkonline.com/football-jobs/xfl/xfl-jobs" text="Careers" primary />
        <FooterItem target="/news" text="News" primary />
        <FooterItem target="/faq" text="FAQ" primary />
        <FooterItem
          target={'https://www.xflshop.com/'
            + '?utm_source=XFL&utm_medium=Dotcom&utm_term=top&utm_content=link&utm_campaign=nav'}
          text="Shop"
          primary
        />
      </FooterRow>
      <FooterRow className="footer-row--small">
        { modals && modals.contactus && modals.contactus.content && <FooterItem text="Contact Us" overlay="contactus" show={showModal} /> }
      </FooterRow>
      <FooterRow className="footer-row--small footer-row--light footer-row--top-gap">
        <FooterItem text="Terms &amp; Conditions" target="/termsandconditions" primary/>
        <FooterItem text="Privacy Policy" target="/privacypolicy" primary />
      </FooterRow>
      <FooterRow>
        <Copyright parent="footer" />
      </FooterRow>
    </FooterWrapper>
  );
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer/components/footer.js